var _path, _path2, _path3, _circle, _circle2, _path4, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.499 58.5C45.5153 58.5 58.499 45.5163 58.499 29.5C58.499 13.4837 45.5153 0.5 29.499 0.5C13.4828 0.5 0.499023 13.4837 0.499023 29.5C0.499023 45.5163 13.4828 58.5 29.499 58.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 45.8333C40.0577 45.8333 44.8333 41.0577 44.8333 35.1667C44.8333 29.2756 40.0577 24.5 34.1667 24.5C28.2756 24.5 23.5 29.2756 23.5 35.1667C23.5 41.0577 28.2756 45.8333 34.1667 45.8333Z",
    fill: "#DAE7FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0147 20.0506V18.5389C24.0147 17.4251 24.9247 16.5258 26.0384 16.5391L33.9341 16.6327C34.4563 16.6389 34.9553 16.8491 35.3246 17.2183L39.9246 21.8184M34 37.0005L34.2691 37.2866C35.0423 38.1088 36.3422 38.1287 37.1402 37.3307L44.8744 29.5965C45.6554 28.8155 45.6554 27.5492 44.8744 26.7681L43.4602 25.3539",
    stroke: "#6895F5",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0253,
    cy: 22.5254,
    r: 2,
    transform: "rotate(-45 30.0253 22.5254)",
    stroke: "#6895F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6925,
    cy: 23.5859,
    r: 0.5,
    transform: "rotate(-45 41.6925 23.5859)",
    fill: "#6895F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1628 33.156L22.7126 42.7058C23.4936 43.4868 24.76 43.4868 25.541 42.7058L33.3192 34.9276C34.1002 34.1465 34.1002 32.8802 33.3192 32.0992L23.7694 22.5494C23.4002 22.1801 22.9011 21.9699 22.3789 21.9637L14.5074 21.8704C13.3843 21.8571 12.4705 22.7709 12.4838 23.894L12.5772 31.7655C12.5834 32.2877 12.7936 32.7867 13.1628 33.156Z",
    stroke: "#6895F5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4701,
    cy: 27.8564,
    r: 2,
    transform: "rotate(-45 18.4701 27.8564)",
    stroke: "#6895F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.40457ead6b70b4aca5bb8e10c2c2429b.svg";
export { ForwardRef as ReactComponent };